import { useAppStateSelector } from '../useAppStateSelector'
import { LoadingStates } from '@dashboard/lib/types'
import { useAppDispatch } from '../useAppDispatch'
import {
  updateUserSettings as updateUser,
  UpdateSettingsParams,
} from '@dashboard/store/actions/user/updateSettings'

interface Props {
  state: LoadingStates
  post: () => void
}

export function updateUserSettings(params: UpdateSettingsParams): Props {
  const { updateSettingsState } = useAppStateSelector(state => state.user)
  const state = updateSettingsState
  const dispatch = useAppDispatch()
  const post = () => dispatch(updateUser(params))

  return {
    state,
    post,
  }
}
